export type AuthBridgePayload =
  | {
      type: "AUTH_SUCCESS";
      token: string;
      user: {
        id: string;
        name?: string;
        email?: string;
      };
    }
  | {
      type: "AUTH_RESTORE";
      token: string;
    }
  | {
      type: "LOGOUT";
    };

declare global {
  interface Window {
    ReactNativeWebView?: {
      postMessage: (message: string) => void;
    };
  }
}

export const hasReactNativeWebView = () => {
  if (typeof window === "undefined") return false;

  return typeof window.ReactNativeWebView?.postMessage === "function";
};

export const postToReactNativeWebView = (payload: AuthBridgePayload) => {
  if (!hasReactNativeWebView()) return false;

  try {
    window.ReactNativeWebView?.postMessage(JSON.stringify(payload));
    return true;
  } catch (error) {
    console.error("Erro ao enviar mensagem para o app nativo:", error);
    return false;
  }
};

export const notifyAuthSuccess = (
  token: string,
  user: { _id: string; name?: string; email?: string }
) => {
  return postToReactNativeWebView({
    type: "AUTH_SUCCESS",
    token,
    user: {
      id: user._id,
      name: user.name,
      email: user.email,
    },
  });
};

export const notifyAuthRestore = (token: string) => {
  return postToReactNativeWebView({
    type: "AUTH_RESTORE",
    token,
  });
};

export const notifyLogout = () => {
  return postToReactNativeWebView({
    type: "LOGOUT",
  });
};
